import { ColorSystemDefinition } from "@ancon/wildcat-ui/shared";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFormContext } from "react-hook-form";
import { Button } from "reactstrap";
import { styled } from "styled-components";
import { FontVariant } from "../../../constants/fonts";

const Modal = styled.div`
  padding: 30px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
  border-top-left-radius: 40px;
  border-top-right-radius: 40px;
  width: 390px;
`;

const CloseButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

const CircleButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  height: 40px;
  width: 40px;
  border-radius: 50%;
`;

const ModalTitle = styled.h4`
  font-size: 24px;
  font-weight: bold;
  margin-top: 20px;
`;

const ModalBody = styled.div``;

const ActionButton = styled(Button)`
  border-radius: 30px;
  height: 48px;
  margin-bottom: 5px;
`;

const ActionsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const TimeElementsContainer = styled.div`
  padding-top: 40px;
  padding-bottom: 40px;
`;
const LowTimeContainer = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: row;
  padding-left: 20px;
  padding-right: 20px;
`;
const SelectedTimeContainer = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: row;
  padding-left: 20px;
  padding-right: 20px;
`;

const TimeSet = styled.div<{ selected?: boolean }>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${props => (props.selected ? 1 : 0.3)};
  ${props =>
    props.selected &&
    `padding: 10px;
     margin:5px;
     border-radius: 10px;`}
`;

export default function BottomSheet() {
  const { watch } = useFormContext<ColorSystemDefinition>();
  const values = watch();
  const { primary } = values;
  const { color, content, buttons, highlights } = primary;
  const { alt_1: primaryHighlightAlt1 } = highlights;
  const { default: defaultContentColor } = content;
  const { default: defaultButton } = buttons;

  return (
    <Modal
      style={{
        backgroundColor: color,
      }}
    >
      <CloseButtonContainer>
        <CircleButton
          style={{
            backgroundColor: defaultButton.color,
          }}
        >
          <FontAwesomeIcon icon={faClose} color={defaultButton.content} />
        </CircleButton>
      </CloseButtonContainer>

      <ModalTitle
        style={{
          color: defaultContentColor,
          fontFamily: FontVariant.PrimaryBold,
        }}
      >
        Order Later
      </ModalTitle>
      <ModalBody>
        <TimeElementsContainer>
          <LowTimeContainer>
            <TimeSet
              style={{
                color: defaultContentColor,
                fontFamily: FontVariant.PrimaryRegular,
              }}
            >
              Thursday
            </TimeSet>
            <TimeSet
              style={{
                color: defaultContentColor,
                fontFamily: FontVariant.PrimaryRegular,
              }}
            >
              03:50
            </TimeSet>
          </LowTimeContainer>
          <SelectedTimeContainer>
            <TimeSet
              style={{
                color: defaultContentColor,
                background: primaryHighlightAlt1,
                fontFamily: FontVariant.PrimaryRegular,
              }}
              selected
            >
              Thursday
            </TimeSet>
            <TimeSet
              style={{
                color: defaultContentColor,
                background: primaryHighlightAlt1,
                fontFamily: FontVariant.PrimaryRegular,
              }}
              selected
            >
              03:50
            </TimeSet>
          </SelectedTimeContainer>
          <LowTimeContainer>
            <TimeSet
              style={{
                color: defaultContentColor,
                fontFamily: FontVariant.PrimaryRegular,
              }}
            >
              Thursday
            </TimeSet>
            <TimeSet
              style={{
                color: defaultContentColor,
                fontFamily: FontVariant.PrimaryRegular,
              }}
            >
              03:50
            </TimeSet>
          </LowTimeContainer>
        </TimeElementsContainer>

        <ActionsContainer>
          <ActionButton
            style={{
              border: "none",
              backgroundColor: defaultButton.color,
              color: defaultButton.content,
              fontFamily: FontVariant.PrimaryRegular,
            }}
          >
            OK
          </ActionButton>
        </ActionsContainer>
      </ModalBody>
    </Modal>
  );
}
